module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-outside-map.e70e29ec.png";